// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./default_bank_logo.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./secure_banking_logo.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.Modal.overlay {
  z-index: 3000;
}

div.Modal.window.medium.ConnectBankModal {
  overflow: visible;
  z-index: 3001;
}
div.Modal.window.medium.ConnectBankModal footer {
  height: 34px;
}
div.Modal.window.medium.ConnectBankModal .Button.accept.disabled {
  background-color: #075E42;
  height: 12px;
  background-position: bottom;
}
div.Modal.window.medium.ConnectBankModal .Button.accept.disabled .loadingEllipsis {
  height: 12px;
}
div.Modal.window.medium.ConnectBankModal .Button.accept.disabled .loadingEllipsis .lds-ellipsis {
  height: 12px;
}
div.Modal.window.medium.ConnectBankModal .Button.accept.disabled .loadingEllipsis .lds-ellipsis div {
  background: #E8E9F0;
}
div.Modal.window.medium.ConnectBankModal div.SelectInput > div.select > div.selected-value {
  height: 42px;
}
div.Modal.window.medium.ConnectBankModal div.content {
  padding: 36px 48px;
  overflow: visible;
}
div.Modal.window.medium.ConnectBankModal div.content div.react-spinner {
  margin-top: 36px;
}
div.Modal.window.medium.ConnectBankModal div.content div.ConnectBankModal__title {
  font-weight: bold;
  color: #002E33;
  font-size: 22px;
  text-align: left;
}
div.Modal.window.medium.ConnectBankModal div.content div.Controlled.Input {
  width: 50%;
  margin: 0;
  padding-top: 36px;
  height: 42px;
}
div.Modal.window.medium.ConnectBankModal div.content div.Controlled.Input span.Label {
  width: 80px;
  line-height: 42px;
  font-size: 14px;
  font-weight: 500;
  color: #002E33;
}
div.Modal.window.medium.ConnectBankModal div.content div.Controlled.Input span.Label + .Controlled {
  width: 162px;
  margin-left: 88px;
}
div.Modal.window.medium.ConnectBankModal div.content div.Controlled.Input span.selected-value {
  line-height: 28px;
  font-size: 14px;
  font-weight: 500;
  color: #002E33;
}
div.Modal.window.medium.ConnectBankModal div.content div.Controlled.Input span.arrow {
  width: 32px;
}
div.Modal.window.medium.ConnectBankModal div.content div.Controlled.Input div.option {
  padding: 12px 8px;
  font-size: 14px;
  font-weight: 500;
  color: #002E33;
  cursor: pointer;
}
div.Modal.window.medium.ConnectBankModal div.content div.ConnectBankModal__BanksDropSelect {
  padding-top: 24px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-weight: 500;
  color: #002E33;
  font-size: 14px;
}
div.Modal.window.medium.ConnectBankModal div.content div.ConnectBankModal__BanksDropSelect__label {
  line-height: 42px;
  width: 200px;
  text-overflow: ellipsis;
}
div.Modal.window.medium.ConnectBankModal div.content div.ConnectBankModal__BanksDropSelect__selector {
  width: 100%;
}
div.Modal.window.medium.ConnectBankModal div.content div.ConnectBankModal__BanksDropSelect__selector .zervantDropSelect__menuContainer {
  border-radius: 2px;
  -webkit-box-shadow: 0 10px 15px 0 rgba(38, 40, 47, 0.15);
          box-shadow: 0 10px 15px 0 rgba(38, 40, 47, 0.15);
  background-color: #FFF;
}
div.Modal.window.medium.ConnectBankModal div.content div.ConnectBankModal__BanksDropSelect__selector .zervantDropSelect__inputContainer {
  height: 42px;
}
div.Modal.window.medium.ConnectBankModal div.content div.ConnectBankModal__BanksDropSelect__selector .zervantDropSelect__clearIcon {
  left: 348px;
}
div.Modal.window.medium.ConnectBankModal div.content div.ConnectBankModal__BanksDropSelect__selector .zervantDropSelect__menuItems {
  max-height: 240px;
  overflow-y: auto;
  margin: 32px 0;
}
div.Modal.window.medium.ConnectBankModal div.content div.ConnectBankModal__BanksDropSelect__selector .zervantDropSelect__Item {
  padding: 12px 24px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  cursor: pointer;
}
div.Modal.window.medium.ConnectBankModal div.content div.ConnectBankModal__BanksDropSelect__selector .zervantDropSelect__Item:hover {
  background: #F5F6F9;
}
div.Modal.window.medium.ConnectBankModal div.content div.ConnectBankModal__BanksDropSelect__selector .zervantDropSelect__Logo {
  width: 100px;
  height: 12px;
}
div.Modal.window.medium.ConnectBankModal div.content div.ConnectBankModal__BanksDropSelect__selector .zervantDropSelect__defaultLogo {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
  background-size: 32px;
  width: 40px;
  height: 32px;
}
div.Modal.window.medium.ConnectBankModal div.content div.ConnectBankModal__BanksDropSelect__selector .zervantDropSelect__menuItem {
  width: 100%;
  padding-left: 16px;
  margin-top: -10px;
}
div.Modal.window.medium.ConnectBankModal div.content div.ConnectBankModal__BanksDropSelect__selector .zervantDropSelect__menuEmptyMessage {
  display: none;
}
div.Modal.window.medium.ConnectBankModal div.content div.ConnectBankModal__searchTextInvalid {
  padding-left: 145px;
  padding-top: 20px;
  line-height: 16px;
  text-align: left;
  color: #697588;
  font-size: 12px;
  font-weight: 500;
}
div.Modal.window.medium.ConnectBankModal div.content div.ConnectBankModal__searchTextInvalid div.Button {
  font-weight: 500;
  padding-left: 4px;
}
div.Modal.window.medium.ConnectBankModal div.content div.ConnectBankModal__warningMessageForUser {
  padding-left: 145px;
  padding-top: 20px;
  line-height: 16px;
  text-align: left;
  color: #002E33;
  font-size: 12px;
  font-weight: 500;
}
div.Modal.window.medium.ConnectBankModal div.content div.ConnectBankModal__warningMessageForUser div.Button {
  font-weight: 500;
  padding-left: 4px;
}
div.Modal.window.medium.ConnectBankModal div.content div.Controlled.RadioInput.Input {
  padding-top: 10px;
}
div.Modal.window.medium.ConnectBankModal div.content div.Controlled.RadioInput.Input div.Controlled.Radios {
  position: absolute;
  padding-top: 26px;
  margin-left: 145px;
}
div.Modal.window.medium.ConnectBankModal div.content div.Controlled.RadioInput.Input span.Label {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 520px !important;
  height: 180px;
  line-height: 18px !important;
  padding-top: 26px;
}
div.Modal.window.medium.ConnectBankModal div.content div.Controlled.RadioInput.Input span.Label span {
  width: 100px;
  white-space: normal;
}
div.Modal.window.medium.ConnectBankModal div.content div.Controlled.RadioInput.Input span.Label div {
  height: auto;
  width: 18px;
}
div.Modal.window.medium.ConnectBankModal div.content div.Controlled.RadioInput.Input span.Label div div.OverlayTrigger {
  width: 300px;
  height: -webkit-fit-content;
  height: -moz-fit-content;
  height: fit-content;
  white-space: normal;
  padding: 0 12px 20px;
}
div.Modal.window.medium.ConnectBankModal div.content div.Controlled.RadioInput.Input .radio {
  width: 300px;
  padding-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #002E33;
}
div.Modal.window.medium.ConnectBankModal div.content div.Controlled.RadioInput.Input .radio label {
  vertical-align: baseline;
  vertical-align: initial;
}
div.Modal.window.medium.ConnectBankModal div.content div.ConnectBankModal__description {
  padding-top: 36px;
  padding-left: 90px;
  color: #697588;
  font-size: 12px;
  text-align: left;
}
div.Modal.window.medium.ConnectBankModal div.content div.ConnectBankModal__description__title {
  font-weight: bold;
  margin-left: 55px;
  margin-top: 25px;
}
div.Modal.window.medium.ConnectBankModal div.content div.ConnectBankModal__description__body {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
div.Modal.window.medium.ConnectBankModal div.content div.ConnectBankModal__description__body__text {
  padding-top: 10px;
  font-weight: 500;
  line-height: 18px;
  margin-left: 55px;
}
div.Modal.window.medium.ConnectBankModal div.content div.ConnectBankModal__description__body__logo {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center;
  background-size: 58px;
  height: 58px;
  width: 260px;
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/client/components/banking/BankingModals/ConnectBankModal.scss","webpack://./src/client/Global/Colors.scss"],"names":[],"mappings":"AAEA;EACC,aAAA;AADD;;AAIA;EACE,iBAAA;EACA,aAAA;AADF;AAGE;EACE,YAAA;AADJ;AAKE;EACE,yBCYO;EDXP,YAAA;EACA,2BAAA;AAHJ;AAII;EACE,YAAA;AAFN;AAGM;EACE,YAAA;AADR;AAEQ;EACE,mBCiCD;ADjCT;AAME;EACE,YAAA;AAJJ;AAOE;EACE,kBAAA;EACA,iBAAA;AALJ;AAOI;EACE,gBAAA;AALN;AAQI;EACE,iBAAA;EACA,cC1CS;ED2CT,eAAA;EACA,gBAAA;AANN;AASI;EACE,UAAA;EACA,SAAA;EACA,iBAAA;EACA,YAAA;AAPN;AASM;EACE,WAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cC1DO;ADmDf;AAUM;EACE,YAAA;EACA,iBAAA;AARR;AAWM;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cCtEO;AD6Df;AAYM;EACE,WAAA;AAVR;AAaM;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cCjFO;EDkFP,eAAA;AAXR;AAeI;EACE,iBAAA;EACA,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,gBAAA;EACA,cC1FS;ED2FT,eAAA;AAbN;AAeM;EACE,iBAAA;EACA,YAAA;EACA,uBAAA;AAbR;AAgBM;EACE,WAAA;AAdR;AAkBU;EACE,kBAAA;EACA,wDAAA;UAAA,gDAAA;EACA,sBCrGJ;ADqFR;AAmBU;EACE,YAAA;AAjBZ;AAoBU;EACE,WAAA;AAlBZ;AAqBU;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;AAnBZ;AAsBU;EACE,kBAAA;EACA,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,eAAA;AApBZ;AAsBY;EACE,mBC1EL;ADsDT;AAwBU;EACE,YAAA;EACA,YAAA;AAtBZ;AAyBU;EACE,oEAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AAvBZ;AA0BU;EACE,WAAA;EACA,kBAAA;EACA,iBAAA;AAxBZ;AA2BU;EACE,aAAA;AAzBZ;AA+BI;EACE,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cCjHG;EDkHH,eAAA;EACA,gBAAA;AA7BN;AA+BM;EACE,gBAAA;EACA,iBAAA;AA7BR;AAiCI;EACE,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cCnLS;EDoLT,eAAA;EACA,gBAAA;AA/BN;AAiCM;EACE,gBAAA;EACA,iBAAA;AA/BR;AAmCI;EACE,iBAAA;AAjCN;AAkCM;EACE,kBAAA;EACA,iBAAA;EACA,kBAAA;AAhCR;AAkCM;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,uBAAA;EACA,aAAA;EACA,4BAAA;EACA,iBAAA;AAhCR;AAiCQ;EACE,YAAA;EACA,mBAAA;AA/BV;AAiCQ;EACE,YAAA;EACA,WAAA;AA/BV;AAgCU;EACE,YAAA;EACA,2BAAA;EAAA,wBAAA;EAAA,mBAAA;EACA,mBAAA;EACA,oBAAA;AA9BZ;AAmCM;EACE,YAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cC/NO;AD8Lf;AAmCQ;EACE,wBAAA;EAAA,uBAAA;AAjCV;AAsCI;EACE,iBAAA;EACA,kBAAA;EACA,cCvLG;EDwLH,eAAA;EACA,gBAAA;AApCN;AAsCM;EACE,iBAAA;EACA,iBAAA;EACA,gBAAA;AApCR;AAuCM;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;AArCR;AAuCQ;EACE,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AArCV;AAwCQ;EACE,oEAAA;EACA,qBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;AAtCV","sourcesContent":["@import \"../../../Global/Colors.scss\";\n\ndiv.Modal.overlay {\n z-index: 3000;\n}\n\ndiv.Modal.window.medium.ConnectBankModal {\n  overflow: visible;\n  z-index: 3001;\n\n  footer {\n    height: 34px;\n  }\n\n\n  .Button.accept.disabled {\n    background-color: $Green140;\n    height: 12px;\n    background-position: bottom;\n    .loadingEllipsis {\n      height: 12px;\n      .lds-ellipsis {\n        height: 12px;\n        div {\n          background: $Gray30;\n        }\n      }\n    }\n  }\n\n  div.SelectInput > div.select > div.selected-value {\n    height: 42px;\n  }\n\n  div.content {\n    padding: 36px 48px;\n    overflow: visible;\n\n    div.react-spinner {\n      margin-top: 36px;\n    }\n\n    div.ConnectBankModal__title {\n      font-weight: bold;\n      color: $DeepSeaGreen;\n      font-size: 22px;\n      text-align: left;\n    }\n\n    div.Controlled.Input {\n      width: 50%;\n      margin: 0;\n      padding-top: 36px;\n      height: 42px;\n\n      span.Label {\n        width: 80px;\n        line-height: 42px;\n        font-size: 14px;\n        font-weight: 500;\n        color: $DeepSeaGreen;\n      }\n\n      span.Label + .Controlled {\n        width: 162px;\n        margin-left: 88px;\n      }\n\n      span.selected-value {\n        line-height: 28px;\n        font-size: 14px;\n        font-weight: 500;\n        color: $DeepSeaGreen;\n      }\n\n      span.arrow {\n        width: 32px;\n      }\n\n      div.option {\n        padding: 12px 8px;\n        font-size: 14px;\n        font-weight: 500;\n        color: $DeepSeaGreen;\n        cursor: pointer;\n      }\n    }\n\n    div.ConnectBankModal__BanksDropSelect {\n      padding-top: 24px;\n      display: flex;\n      font-weight: 500;\n      color: $DeepSeaGreen;\n      font-size: 14px;\n\n      &__label {\n        line-height: 42px;\n        width: 200px;\n        text-overflow: ellipsis;\n      }\n\n      &__selector {\n        width: 100%;\n\n        .zervantDropSelect {\n\n          &__menuContainer {\n            border-radius: 2px;\n            box-shadow: 0 10px 15px 0 rgba($Gray200, 0.15);\n            background-color: $White;\n          }\n\n          &__inputContainer {\n            height: 42px;\n          }\n\n          &__clearIcon {\n            left: 348px;\n          }\n\n          &__menuItems {\n            max-height: 240px;\n            overflow-y: auto;\n            margin: 32px 0;\n          }\n\n          &__Item {\n            padding: 12px 24px;\n            display: flex;\n            cursor: pointer;\n\n            &:hover {\n              background: $Gray20;\n            }\n          }\n\n          &__Logo {\n            width: 100px;\n            height: 12px;\n          }\n\n          &__defaultLogo {\n            background: url(./default_bank_logo.svg) no-repeat center;\n            background-size: 32px;\n            width: 40px;\n            height: 32px;\n          }\n\n          &__menuItem {\n            width: 100%;\n            padding-left: 16px;\n            margin-top: -10px;\n          }\n\n          &__menuEmptyMessage {\n            display: none;\n          }\n        }\n      }\n    }\n\n    div.ConnectBankModal__searchTextInvalid {\n      padding-left: 145px;\n      padding-top: 20px;\n      line-height: 16px;\n      text-align: left;\n      color: $Gray90;\n      font-size: 12px;\n      font-weight: 500;\n\n      div.Button {\n        font-weight: 500;\n        padding-left: 4px;\n      }\n    }\n\n    div.ConnectBankModal__warningMessageForUser {\n      padding-left: 145px;\n      padding-top: 20px;\n      line-height: 16px;\n      text-align: left;\n      color: $DeepSeaGreen;\n      font-size: 12px;\n      font-weight: 500;\n\n      div.Button {\n        font-weight: 500;\n        padding-left: 4px;\n      }\n    }\n\n    div.Controlled.RadioInput.Input {\n      padding-top: 10px;\n      div.Controlled.Radios {\n        position: absolute;\n        padding-top: 26px;\n        margin-left: 145px;\n      }\n      span.Label {\n        display: flex;\n        width: 520px !important;\n        height: 180px;\n        line-height: 18px !important;\n        padding-top: 26px;\n        span {\n          width: 100px;\n          white-space: normal;\n        }\n        div {\n          height: auto;\n          width: 18px;\n          div.OverlayTrigger {\n            width: 300px;\n            height: fit-content;\n            white-space: normal;\n            padding: 0 12px 20px;\n          }\n        }\n      }\n\n      .radio {\n        width: 300px;\n        padding-bottom: 8px;\n        font-size: 14px;\n        font-weight: 500;\n        color: $DeepSeaGreen;\n\n        label {\n          vertical-align: unset;\n        }\n      }\n    }\n\n    div.ConnectBankModal__description {\n      padding-top: 36px;\n      padding-left: 90px;\n      color: $Gray90;\n      font-size: 12px;\n      text-align: left;\n\n      &__title {\n        font-weight: bold;\n        margin-left: 55px;\n        margin-top: 25px;\n      }\n\n      &__body {\n        display: flex;\n\n        &__text {\n          padding-top: 10px;\n          font-weight: 500;\n          line-height: 18px;\n          margin-left: 55px;\n        }\n\n        &__logo {\n          background: url(./secure_banking_logo.svg) no-repeat center;\n          background-size: 58px;\n          height: 58px;\n          width: 260px;\n          margin-top: 10px;\n        }\n      }\n    }\n  }\n}\n","// Brand\n$ElectricGreen: #01FF94;\n$DeepSeaGreen: #002E33;\n$Lavender: #DBD4FF;\n$DayGrey: #EDF1F7;\n\n// Primary\n$Black: #000;\n$White: #FFF;\n$Green: #00E383;\n$Yellow: #FBDB3F;\n$Red: #D92D20;\n$Purple: #5E46D2;\n\n// Blues\n$Blue140: #131C3E;\n$Blue120: #1E267D;\n$Blue110: #2258CE;\n$Blue90: #5E8BEF;\n$Blue60: #7CA2F8;\n$Blue10: #D0E6FE;\n$Blue5: #E4F1FF;\n\n// Purples\n$Purple140: #5D4DAE;\n$Purple20: #F8F6FF;\n\n// Greens\n$Green140: #075E42;\n$Green120: #078E64;\n$Green110: #29B574;\n$Green90: #32D583;\n$Green60: #6CE9A6;\n$Green20: #BAEFCB;\n$Green10: #DDF3E4;\n$Green5: #E8FFF0;\n\n// Yellows\n$Yellow220: #735714;\n$Yellow200: #8F7638;\n$Yellow120: #DCB11A;\n$Yellow30: #FFF8B8;\n$Yellow10: #FFF9CC;\n\n// Reds\n$Red120: #951307;\n$Red110: #C94337;\n$Red90: #F07B70;\n$Red10: #F7DDD9;\n$Red5: #FFF8F6;\n\n// Grays\n$Gray200: #26282F;\n$Gray90: #697588;\n$Gray60: #A7A9B4;\n$Gray50: #D3D6DF;\n$Gray40: #D9DCE5;\n$Gray30: #E8E9F0;\n$Gray20: #F5F6F9;\n$Gray10: #F6F9FF;\n\n// Legacy color variables: Remove these after deprecating @zervant/reactcomponents package\n$shadowColor: #5F6766;\n$normalTextColor: $Gray200;\n$normalBorderColor: $Gray30;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
